'use strict';
///*------------------------------------
///* скролл по секциям    
///*-------------------------------------
const scrollSection = (() => {
  const body = document.body,
    sections = [...body.querySelectorAll('.section[data-section]')]; 
  let arrOffset = [], links = [];

  function showSection(e) {
    e.preventDefault();
    arrOffset = sections.map((item) => item.offsetTop);
    let hash = e?this.getAttribute('href'):window.location.hash,
      sectionAct = body.querySelector(`.section[data-section="${hash.replace(/#/,'')}"`),  
      index = sections.indexOf(sectionAct);
    let scrollPos = arrOffset[index];
    if(e) {
      animateMove(e, scrollPos);
    }
    else {
      document.documentElement.scrollTop = document.body.scrollTop = scrollPos;
    }
  }

  const animate = (options) => {
    
    let startPos = body.scrollTop || document.documentElement.scrollTop;
    let start = performance.now();
    requestAnimationFrame(function _animate(time) {
    // timeFraction от 0 до 1
      let timeFraction = (time - start) / options.duration;
      if (timeFraction > 1) {
        timeFraction = 1;
      }
      // текущее состояние анимации
      let progress = options.timing(timeFraction);
      options.move(progress, startPos);
      if (timeFraction < 1) {
        requestAnimationFrame(_animate);
      }
    });
  };

  const animateMove = (e, scrollPos) => {
    e.preventDefault();
    animate({
      duration: 800,
      timing: function(timeFraction) {
        return timeFraction;
      },
      move: function(progress, startPos) {
        document.documentElement.scrollTop = document.body.scrollTop = startPos + (scrollPos- startPos)*(progress);
      },
    });
  };

  const init = () => {
    links = [...body.querySelectorAll('.hamburg-menu__link')];
    links.forEach(function(el) {
      el.addEventListener('click', showSection);
    });
    body.querySelector('#move2second').addEventListener('click', showSection);
  };
  return {init};
})();
export default scrollSection;


// WEBPACK FOOTER //
// ./app/components/scroll.js